export function toAnalyticsErrorCode(error: unknown, fallbackCode: string) {
  if (error instanceof Error && error.message.trim()) {
    return normalizeAnalyticsErrorCode(error.message)
  }

  if (typeof error === "string" && error.trim()) {
    return normalizeAnalyticsErrorCode(error)
  }

  return fallbackCode
}

function normalizeAnalyticsErrorCode(value: string) {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_/-]+/g, "_")
    .replace(/[/_-]+/g, "_")
    .replace(/^_+|_+$/g, "")

  if (!normalized) {
    throw new Error("[analytics] empty normalized error code")
  }

  return normalized.slice(0, 80)
}
